import { render, staticRenderFns } from "./TrustLevels.vue?vue&type=template&id=474008c2&scoped=true"
import script from "./TrustLevels.vue?vue&type=script&lang=js"
export * from "./TrustLevels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474008c2",
  null
  
)

export default component.exports